













import { Component, Vue } from "vue-property-decorator";
import Card from "@/components/Card.vue";

@Component({
  components: {
    Card
  }
})
export default class ProcessSection extends Vue {
  data() {
    return {
      cardData: [
        {
          additionalClass: "",
          cardHeading: "Free Consultation",
          cardDescription: "Our sales agents will do an on-site visit to provide an in-depth explanation of our services, technology, and process and to provide an estimate for the project efforts.",
        },
        {
          additionalClass: "",
          cardHeading: "Photoshoot",
          cardDescription: "Our photographers will perform a photo shoot of your location at an agreed date and time.",
        },
        {
          additionalClass: "",
          cardHeading: "Design",
          cardDescription: "PeekPeek's UX/UI designers will design the layout of your new WebTour. Each function will be tested with focus groups to ensure an optimal user experience.", 
        },
        {
          additionalClass: "",
          cardHeading: "Final Review",
          cardDescription: "After we have finished wireframe mock ups, we will present the deliverable to make sure you are satisfied with your new tour.", 
        },
        {
          additionalClass: "",
          cardHeading: "Hosting Service",
          cardDescription: "We will host your tour on Amazon WebServer. You can choose your custom URL. We will perform monthly maintenance service and update your tour content if needed.", 
        },
      ]
    };
  }
}
